// The day's atmos kit (twelve pads of atmosphere and gentle effects, atmosKits.ts): chosen per drum
// kit by weight, never yesterday's; days planned before atmos kits get one from their seed
// (`normalizePeriodDef`).
import { ATMOS_KIT_IDS, ATMOS_KIT_WEIGHTS, type AtmosKitId } from "./atmosKits";
import type { KitId } from "./kits";
import { mixSeed, Rng } from "./rng";

/** The atmos kit for a day of drum kit `kit` (its own stream of the day's seed). */
export function defaultAtmosKit(kit: KitId, seed: number, exclude: readonly string[] = []): AtmosKitId {
  const weights = ATMOS_KIT_WEIGHTS[kit] ?? {};
  const all = ATMOS_KIT_IDS.map((id) => ({ item: id, weight: weights[id] ?? 0.3 }));
  const items = all.filter((x) => !exclude.includes(x.item));
  return new Rng(mixSeed(seed >>> 0, 0xa7a05)).weighted(items.length ? items : all);
}
